import { ScrollablePdf } from '~/components/terms/scrollable-terms/scrollable-pdf.component';
import { StyledModal } from './pdf-review.style';

export interface PdfReviewDialogProps {
  base64Pdf: string;
  onApprove: (base64Pdf: string) => void;
  onCancel: () => void;
}

export const PdfReviewDialog = ({ base64Pdf, onApprove, onCancel }: PdfReviewDialogProps) => {
  return (
    <StyledModal
      onDismiss={onCancel}
      size="large"
      aria-label="review-pdf-document"
      data-testid="pdf-review-dialog"
    >
      <StyledModal.HeaderCentered title="Review PDF document" onClose={onCancel} />
      <ScrollablePdf pdfUrl={base64Pdf} />
      <StyledModal.FooterStacked
        primaryText="Ok"
        onSubmit={() => onApprove(base64Pdf)}
        secondaryText="Cancel"
        onCancel={onCancel}
      />
    </StyledModal>
  );
};
